'use strict';

/**
 * @ngdoc function
 * @name prepApp.controller:CoursetasksdayCtrl
 * @description
 * # CoursetasksdayCtrl
 * Controller of the prepApp
 */
angular.module('prepApp')
    .controller('CourseTasksDayController', function (CourseTaskService, NgTableParams) {
        var vm = this;
        vm.taskList = [];
        vm.selDays = [
            { name: 'gestern', doDate: '', plusDays: -1, doneIsNull: 2 },
            { name: 'gestern (erledigt)', doDate: '', plusDays: -1, doneIsNull: 1, doneDate: '' },
            { name: 'heute', doDate: '', plusDays: 0, doneIsNull: 2 },
            { name: 'heute (erledigt)', doDate: '', plusDays: 0, doneIsNull: 1, doneDate: '' },
            { name: 'morgen', doDate: '', plusDays: 1, doneIsNull: 2 },
            { name: '3 Tage', doDate: '', plusDays: 3, doneIsNull: 2 },
            { name: '1 Woche', doDate: '', plusDays: 7, doneIsNull: 2 },
            { name: '2 Wochen', doDate: '', plusDays: 14, doneIsNull: 2 }
            // , { name: 'Test', doDate: '', plusDays: -250 }
        ];
        angular.forEach(vm.selDays, function (value, option) {
            var d = new Date();
            d.setDate(d.getDate() + value.plusDays);
            if (vm.selDays[option].doneIsNull === 1) {
                vm.selDays[option].doneDate = d.toJSON().slice(0, 10);
            }
            vm.selDays[option].doDate = d.toJSON().slice(0, 10);
        });
        vm.hideTaskTable = true;
        vm.showFinishTask = false;
        vm.showRemarkTask = false;
        vm.showDelTask = false;

        vm.toogleDivOrDialog = function (dialog) {
            vm[dialog] = !vm[dialog];
        };

        vm.clickTaskButton = function (task, elementName) {
            vm.selectedTask = task;
            vm.toogleDivOrDialog(elementName);
        };

        vm.showRemarkTaskDialog = function (task, elementName) {
            vm.selectedTask = task;
            vm.toogleDivOrDialog(elementName);
        };

        vm.finishTask = function () {
            vm.pFinishTask = angular.copy(vm.selectedTask);
            vm.pFinishTask.done_date = new Date().toJSON().slice(0, 16);
            CourseTaskService.update(vm.pFinishTask, function (data) {
                vm.taskList.splice(vm.taskList.indexOf(vm.selectedTask), 1);
                vm.taskList.push(data);
                vm.updateTasksList();
            });
            vm.toogleDivOrDialog('showFinishTask');
        };

        vm.delTask = function () {
            CourseTaskService.delete({ id: vm.selectedTask.id }, function () {
                vm.taskList.splice(vm.taskList.indexOf(vm.selectedTask), 1);
                vm.updateTasksList();
                vm.toogleDivOrDialog('showDelTask');
            });
        };

        vm.daySelected = function () {
            if (angular.isDefined(vm.selectedDay.doneDate)) {
                CourseTaskService.query({ do_date_lte: vm.selectedDay.doDate, done_date_eq: vm.selectedDay.doneDate, done_date_isnull: vm.selectedDay.doneIsNull }).$promise.then(function (data) {
                    vm.updateTasksList(data);
                });
            } else {
                CourseTaskService.query({ do_date_lte: vm.selectedDay.doDate, done_date_isnull: vm.selectedDay.doneIsNull }).$promise.then(function (data) {
                    vm.updateTasksList(data);
                });
            }
        };

        vm.updateTasksList = function (data) {
            var actPage = vm.tableParams.parameters().page;
            if (angular.isDefined(data) && data !== null) {
                vm.taskList = [];

                angular.forEach(data, function (task) {
                    vm.taskList.push(task);
                });
            }
            vm.tableParams.settings({
                dataset: vm.taskList
            });
            vm.tableParams.page(actPage);
        };

        vm.cols = [
            { valueExpr: 'task.course.short_name', title: 'Kurs', filter: { 'course.short_name': 'text' }, show: true },
            { valueExpr: 'task.task', title: 'Aufgabe', filter: { task: 'text' }, show: true },
            { valueExpr: 'task.do_date | date:\'dd.MM.yyyy (EEE)\'', title: 'zu erledigen', sortable: 'do_date', show: true },
            { valueExpr: 'task.done_date | date:\'dd.MM.yyyy HH:mm\'', title: 'erledigt', show: true },
            { field: 'action', title: '', dataType: 'command', class: 'actionWidth120' }
        ];

        vm.tableParams = new NgTableParams({ page: 1, count: 10, sorting: { do_date: 'asc' } }, {
            defaultSelectValue: 'Show all',
            dataset: vm.taskList
        });
    });
